import CCPage from './ContractCenter';

export default CCPage;



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/index.jsx